import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myHrChangeRequestsEnabledState = atom({
  key: "myHrChangeRequestsEnabledState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
